import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_MBtn = _resolveComponent("MBtn")!
  const _component_UserNotification = _resolveComponent("UserNotification")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_MvrSummary = _resolveComponent("MvrSummary")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      "is-active": $setup.isWaiting,
      title: "Loading data..."
    }, null, 8 /* PROPS */, ["is-active"]),
    _createVNode(_component_WaitDialog, {
      "is-active": $setup.isWaitingOrder,
      title: "Ordering Violation Prediction..."
    }, null, 8 /* PROPS */, ["is-active"]),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createCommentVNode(" Header Display / Button Options "),
        _createVNode(_component_v_row, {
          justify: "space-between",
          class: "justify-sm-center justify-xs-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "d-flex justify-start" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, "Policy Number: " + _toDisplayString($setup.policyNumber), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, { class: "d-flex justify-end justify-xs-start" }, {
              default: _withCtx(() => [
                ($setup.isDuplicate)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      class: "warning",
                      size: "large",
                      color: "warning",
                      outlined: "",
                      label: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          icon: "mdi-alert-box"
                        }),
                        _cache[3] || (_cache[3] = _createTextVNode(" Unit’s Assigned Driver does not match driver details on Driver’s List - please review. "))
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_MBtn, {
                  color: "primary",
                  "prepend-icon": "mdi-card-account-details",
                  onClick: $setup.onGetViolationPrediction
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Order ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" <v-row>\n\t\t\t<v-col>\n\t\t\t\t<v-alert v-if=\"validationErrorMessages.length > 0\" type=\"error\" variant=\"tonal\" density=\"compact\"\n\t\t\t\t\ttitle=\"Errors on Driver Data\" icon=\"mdi mdi-alert-circle-outline\" class=\"mb-4\" border prominent>\n\t\t\t\t\t<div v-for=\"(error, errorIdx) in validationErrorMessages\" :key=\"errorIdx\">\n\t\t\t\t\t\t<div v-for=\"(msg, i) in error.messages\" :key=\"i\" class=\"text-left\">\n\t\t\t\t\t\t\t• {{ msg }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</v-alert>\n\t\t\t</v-col>\n\t\t</v-row> "),
        _createVNode(_component_v_container, { class: "pa-0" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.validationErrorMessages, (error, index) => {
              return (_openBlock(), _createBlock(_component_UserNotification, {
                key: index,
                message: error.messages.join('\n'),
                type: "error"
              }, null, 8 /* PROPS */, ["message"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_data_table, {
          headers: $setup.headers,
          items: $setup.drivers?.drivers || [],
          class: "text-left elevation-1 mt-6",
          "row-props": $setup.getRowProps,
          "item-key": "driverId",
          hover: "",
          color: "primaryMoe",
          "items-per-page": $setup.itemsPerPage,
          "footer-props": {
				itemsPerPageOptions: [5, 10, 25, 50, -1],
				itemsPerPageText: 'Drivers per page:',
				showFirstLastPage: true
			}
        }, {
          headers: _withCtx(({ columns }) => [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  id: 'headers-' + column.key,
                  key: column.key,
                  class: "font-weight-bold"
                }, [
                  (column.key === 'selected')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createCommentVNode(" Show disabled state when no selectable drivers exist "),
                        ($setup.selectableDriversCount === 0)
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 0,
                              text: "No drivers available for selection - all have existing data"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("span", _mergeProps({ ref_for: true }, props), [
                                  _createVNode(_component_v_checkbox, {
                                    "model-value": false,
                                    disabled: true,
                                    indeterminate: true,
                                    color: "warning",
                                    density: "compact",
                                    "hide-details": ""
                                  })
                                ], 16 /* FULL_PROPS */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createCommentVNode(" Normal select all behavior when selectable drivers exist "),
                              _createVNode(_component_v_checkbox, {
                                "model-value": $setup.selectAllState,
                                indeterminate: $setup.selectAllState === null,
                                "onUpdate:modelValue": $setup.toggleSelectAll,
                                color: "primary",
                                density: "compact",
                                "hide-details": ""
                              }, null, 8 /* PROPS */, ["model-value", "indeterminate", "onUpdate:modelValue"])
                            ], 64 /* STABLE_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_1))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          "item.selected": _withCtx(({ item }) => [
            (item.violationPrediction != null || item.motorVehicleReport != null)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  text: $setup.getDisabledTooltipText(item)
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                      _createVNode(_component_v_checkbox, {
                        "model-value": false,
                        disabled: true,
                        indeterminate: true,
                        color: "warning",
                        density: "compact",
                        "hide-details": ""
                      })
                    ], 16 /* FULL_PROPS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
              : (_openBlock(), _createBlock(_component_v_checkbox, {
                  key: 1,
                  modelValue: item.selected,
                  "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                  disabled: false,
                  indeterminate: false,
                  color: "primary",
                  density: "compact",
                  "hide-details": ""
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
          ]),
          "item.dateOfBirth": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString($setup.formatDate(item.dateOfBirth)), 1 /* TEXT */)
          ]),
          "item.excludedCode": _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: $setup.getToggleColorError(item.excludedCode === 'Y'),
              size: "small",
              rounded: "pill",
              label: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.toYesNoLabel(item.excludedCode)), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
          ]),
          "item.violationPrediction": _withCtx(({ item }) => [
            (item.violationPrediction === null || item.violationPrediction === undefined)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2))
              : (_openBlock(), _createBlock(_component_v_chip, {
                  key: 1,
                  color: $setup.getToggleColorWarning(item.violationPrediction.orderMvr === 'Y'),
                  size: "small",
                  rounded: "pill",
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.violationPrediction.orderMvr === 'Y' ? 'Yes' : 'No'), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
          ]),
          "item.mvrResponse": _withCtx(({ item }) => [
            ((item as DriverTableItem).productProcessingStatusDescription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_v_chip, {
                    color: $setup.getMvrChipColor((item as DriverTableItem).productProcessingStatusDescription!),
                    dark: "",
                    small: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.getMvrResponse(item as DriverTableItem)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]),
                  ((item as DriverTableItem).productProcessingStatusDescription &&
							['Activity Found', 'Hit', 'Hit - Activity Found', 'Additional response - Hit'].includes((item as DriverTableItem).productProcessingStatusDescription!))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            icon: "",
                            size: "small",
                            onClick: ($event: any) => ($setup.openSidebar(item as DriverTableItem))
                          }, props, { color: "primary" }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("mdi-account-file-text")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("span", null, "View MVR Summary", -1 /* HOISTED */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["headers", "items", "row-props", "items-per-page"]),
        _createCommentVNode(" Sidebar for MVR Details "),
        _createVNode(_component_v_navigation_drawer, {
          modelValue: $setup.sidebarOpen,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.sidebarOpen) = $event)),
          location: "right",
          temporary: "",
          width: $setup.drawerWidth
        }, {
          append: _withCtx(() => [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                ($setup.sidebarOpen)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      justify: "space-between"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MBtn, {
                              icon: "mdi-chevron-right",
                              variant: "text",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.sidebarOpen = !$setup.sidebarOpen), ["stop"])),
                              color: "primaryMoe"
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              "prepend-icon": "mdi-send",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.sendDocument())),
                              color: "primary"
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" Send to Onbase ")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            ($setup.sidebarData)
              ? (_openBlock(), _createBlock(_component_MvrSummary, {
                  key: 0,
                  mvrData: $setup.sidebarData
                }, null, 8 /* PROPS */, ["mvrData"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "width"])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}